import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Spinner from "../../components/Spinner";
import { slackInstall } from "../../api";

const SlackInstallationContainer = () => {
  const [searchParams] = useSearchParams();

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const code = searchParams.get("code");

    if (code) {
      setIsLoading(true);

      setTimeout(async () => {
        await slackInstall({
          code,
          authId: Math.floor(1000 + Math.random() * 9000),
        });
      }, 1000);

      setIsLoading(false);
    }
  }, []);

  return (
    <div className="flex flex-col items-center min-h-screen">
      {isLoading ? (
        <div>
          <Spinner loading={isLoading} />
        </div>
      ) : (
        <div className="flex flex-col items-center mt-20">
          <div className="text-2xl font-semibold">
            CodeKickBot has been successfully added to your Slack workspace!
          </div>
          <div className="text-xl font-semibold mt-4">
            We have DM&apos;ed you the next steps
          </div>
        </div>
      )}
    </div>
  );
};

export default SlackInstallationContainer;
